import React from "react";
import { MainInner } from "@/styles/global";
import S from "./TitleTextBlock.styled";
import { nlToBr } from "@/src/helpers";
import { AnimationOnScroll } from "react-animation-on-scroll";

export interface Props {
  animation: string;
  title1: string;
  title2: string;
  text: string;
  subtitle: string;
  limitText: string;
}

const NewsBlock: React.FC<Props> = ({
  animation,
  title1,
  title2,
  text,
  subtitle,
  limitText,
}) => {
  const [isTextLimited, setIsTextLimited] = React.useState(false);

  React.useEffect(() => {
    if (limitText === "yes") {
      setIsTextLimited(true);
    }
  }, [limitText]);

  return (
    <AnimationOnScroll
      animateIn={`animate__${animation}`}
      animateOnce={true}
      initiallyVisible={animation == "none" ? true : false}
      duration={animation === "none" ? 0 : 1}
      delay={animation === "none" ? 0 : 100}
    >
      <MainInner>
        <S.Container>
          <S.TextContainer>
            <S.TitleWrapper>
              <S.Title1>{title1 && title1}</S.Title1>
              <S.Title2>{title2 && title2}</S.Title2>
            </S.TitleWrapper>
            <S.TextWrapper>
              <S.Subtitle>{subtitle && subtitle}</S.Subtitle>
              <S.TextEllipse isTextLimited={isTextLimited}>
                <S.Text isTextLimited={isTextLimited}>
                  {text && nlToBr(text)}
                </S.Text>
              </S.TextEllipse>
              {limitText === "yes" && (
                <>
                  {isTextLimited ? (
                    <S.ShowMore onClick={() => setIsTextLimited(false)}>
                      More +
                    </S.ShowMore>
                  ) : (
                    <S.ShowMore onClick={() => setIsTextLimited(true)}>
                      Less -
                    </S.ShowMore>
                  )}
                </>
              )}
            </S.TextWrapper>
          </S.TextContainer>
        </S.Container>
      </MainInner>
    </AnimationOnScroll>
  );
};

export default NewsBlock;
